;
define("product_detail_to_quote.tpl", function(){});

